@if (side() === 1 || side() === 'left') {
<img src="assets/images/coinflip/coinflip_blue.png" alt="coinflip" />
} @if (side() === 2 || side() === 'right') {
<img src="assets/images/coinflip/coinflip_red.png" alt="coinflip" />
}
